<!-- 提送货单信息详情页（公共组件） -->
<template>
  <div 
    class="wrapper"
    v-loading="loading">
    <span class="t1">基础信息</span>
    <div class="basecont">
      <div v-if="custom.dataType == 1">
        <div class="itemcont" v-for="tag in detailInfo.baseInfoT" :key="tag.bfield">
          <div v-if="tag.bfield==='goodsSideNameCode'" class="item">
            <span class="left">{{ tag.label }}</span>
            <span class="right">{{ tag.val[0] }}<span v-if="tag.val[1]">/</span>{{ tag.val[1] }}</span>
          </div>
          <div v-else-if="tag.bfield==='goodsSideUserNamePhone'" class="item">
            <span class="left">{{ tag.label }}</span>
            <span class="right">{{ tag.val[0] }} {{ tag.val[1] }}</span>
          </div>
          <div v-else class="item">
            <span class="left">{{ tag.label }}</span>
            <span class="right">{{ tag.val }}</span>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="itemcont" v-for="tag in detailInfo.baseInfoS" :key="tag.bfield">
          <div v-if="tag.bfield==='goodsSideNameCode'" class="item">
            <span class="left">{{ tag.label }}</span>
            <span class="right">{{ tag.val[0] }}<span v-if="tag.val[1]">/</span>{{ tag.val[1] }}</span>
          </div>
          <div v-else-if="tag.bfield==='goodsSideUserNamePhone'" class="item">
            <span class="left">{{ tag.label }}</span>
            <span class="right">{{ tag.val[0] }} {{ tag.val[1] }}</span>
          </div>
          <div v-else class="item">
            <span class="left">{{ tag.label }}</span>
            <span class="right">{{ tag.val }}</span>
          </div>
        </div>
      </div>
    </div>
    <el-divider></el-divider>
    <span class="t1">货物信息</span>
    <span class="t1r" @click="clickVersinLog">版本记录</span>
    <div class="goodsCont">
      <el-table
        :data="detailInfo.goodsList"
        :span-method="custom.dataType==1?objectSpanMethodT:objectSpanMethodS"
        style="width:100%;max-height:600px;overflow-y:auto;">
        <template v-if="custom.dataType == 1">
          <el-table-column
            v-for="(item,index) in goodsInfocolumnT"
            :key="index"
            :show-overflow-tooltip="true"
            :prop="item.prop"
            :label="item.col"
            :width="item.width"
            :fixed="item.fixed"
          >
            <template slot-scope="scope">
              <!-- 单价 -->
              <span v-if="scope.column.property==='univalent'">{{scope.row.univalent | dfFormat}}</span>
              <!-- 货物名称/编码 -->
              <span v-else-if="scope.column.property==='goodsNameCode'">{{scope.row.goodsName}}<span v-if="scope.row.goodsName||scope.row.goodsCode">/</span>{{scope.row.goodsCode}}</span>
              <!-- 货物品类名称/编码 -->
              <span v-else-if="scope.column.property==='goodsCategoryNameCode'">{{scope.row.goodsCategoryName}}<span v-if="scope.row.goodsCategoryName||scope.row.goodsCategoryCode">/</span>{{scope.row.goodsCategoryCode}}</span>
              <!-- 货物种类名称/编码 -->
              <span v-else-if="scope.column.property==='goodsTypeNameCode'">{{scope.row.goodsTypeName}}<span v-if="scope.row.goodsTypeName||scope.row.goodsTypeCode">/</span>{{scope.row.goodsTypeCode}}</span>
              <!-- 增值服务 -->
              <el-popover
                placement="right"
                style="min-width:160px"
                trigger="click"
                v-else-if="scope.column.property==='driverServiceStrList' && scope.row.operateType!=3"
              >
                <div v-for="item in serviceDetailArry" :key="item.type">
                  <div class="popover_item" v-if="item.type == 1">
                    <span>代收货款：</span>
                    <span>{{item.quantity}}元</span>
                  </div>
                  <div class="popover_item" v-else-if="item.type == 2">
                    <span>送货上门：</span>
                    <span>{{item.floor}} 货物数量{{item.quantity}}{{item.calculateUnit}}</span>
                  </div>
                  <div class="popover_item" v-else-if="item.type == 3">
                    <span>货物上架：</span>
                    <span>货物数量{{item.quantity}}{{item.calculateUnit}}</span>
                  </div>
                  <div class="popover_item" v-else-if="item.type == 4">
                    <span>位置腾挪：</span>
                    <span>货物数量{{item.quantity}}{{item.calculateUnit}}</span>
                  </div>
                  <div class="popover_item" v-else-if="item.type == 5">
                    <span>退货服务：</span>
                    <span>{{item.quantity}}{{item.calculateUnit}}</span>
                  </div>
                  <div class="popover_item" v-else-if="item.type == 6">
                    <span>装卸搬运：</span>
                    <span>{{item.quantity}}{{item.calculateUnit}}</span>
                  </div>
                </div>
                <span slot="reference" style="cursor:pointer;" @click="clickzzfw(scope.row)">
                  {{scope.row.driverServiceStrList.join('、')}}
                  <i v-if="scope.row.driverServiceStrList.length > 0" class="el-icon-arrow-right"></i>
                </span>
              </el-popover>
              <span @click="clickzzfw(scope.row)" v-else-if="scope.column.property==='driverServiceStrList' && scope.row.operateType==3" style="cursor:pointer;">
                {{scope.row.driverServiceStrList.join('、')}}
                <i v-if="scope.row.driverServiceStrList.length > 0" class="el-icon-arrow-right"></i>
              </span>
              <span v-else>{{(scope.row[scope.column.property] && scope.row[scope.column.property] !== 'null') ? scope.row[scope.column.property] : ''}}</span>
            </template>
          </el-table-column>
        </template>
        <template v-else>
          <el-table-column
            v-for="(item,index) in goodsInfocolumnS"
            :key="index"
            :show-overflow-tooltip="true"
            :prop="item.prop"
            :label="item.col"
            :width="item.width"
            :fixed="item.fixed"
          >
            <template slot-scope="scope">
              <!-- 单价 -->
              <span v-if="scope.column.property==='univalent'">{{scope.row.univalent | dfFormat}}</span>
              <!-- 货物名称/编码 -->
              <span v-else-if="scope.column.property==='goodsNameCode'">{{scope.row.goodsName}}<span v-if="scope.row.goodsName||scope.row.goodsCode">/</span>{{scope.row.goodsCode}}</span>
              <!-- 货物品类名称/编码 -->
              <span v-else-if="scope.column.property==='goodsCategoryNameCode'">{{scope.row.goodsCategoryName}}<span v-if="scope.row.goodsCategoryName||scope.row.goodsCategoryCode">/</span>{{scope.row.goodsCategoryCode}}</span>
              <!-- 货物种类名称/编码 -->
              <span v-else-if="scope.column.property==='goodsTypeNameCode'">{{scope.row.goodsTypeName}}<span v-if="scope.row.goodsTypeName||scope.row.goodsTypeCode">/</span>{{scope.row.goodsTypeCode}}</span>
              <!-- 增值服务 -->
              <el-popover
                placement="right"
                style="min-width:160px"
                trigger="click"
                v-else-if="scope.column.property==='driverServiceStrList' && scope.row.operateType!=3"
              >
                <div v-for="item in serviceDetailArry" :key="item.type">
                  <div class="popover_item" v-if="item.type == 1">
                    <span>代收货款：</span>
                    <span>{{item.quantity}}元</span>
                  </div>
                  <div class="popover_item" v-else-if="item.type == 2">
                    <span>送货上门：</span>
                    <span>{{item.floor}} 货物数量{{item.quantity}}{{item.calculateUnit}}</span>
                  </div>
                  <div class="popover_item" v-else-if="item.type == 3">
                    <span>货物上架：</span>
                    <span>货物数量{{item.quantity}}{{item.calculateUnit}}</span>
                  </div>
                  <div class="popover_item" v-else-if="item.type == 4">
                    <span>位置腾挪：</span>
                    <span>货物数量{{item.quantity}}{{item.calculateUnit}}</span>
                  </div>
                  <div class="popover_item" v-else-if="item.type == 5">
                    <span>退货服务：</span>
                    <span>{{item.quantity}}{{item.calculateUnit}}</span>
                  </div>
                  <div class="popover_item" v-else-if="item.type == 6">
                    <span>装卸搬运：</span>
                    <span>{{item.quantity}}{{item.calculateUnit}}</span>
                  </div>
                </div>
                <span slot="reference" style="cursor:pointer;" @click="clickzzfw(scope.row)">
                  {{scope.row.driverServiceStrList.join('、')}}
                  <i v-if="scope.row.driverServiceStrList.length > 0" class="el-icon-arrow-right"></i>
                </span>
              </el-popover>
              <span @click="clickzzfw(scope.row)" v-else-if="scope.column.property==='driverServiceStrList' && scope.row.operateType==3" style="cursor:pointer;">
                {{scope.row.driverServiceStrList.join('、')}}
                <i v-if="scope.row.driverServiceStrList.length > 0" class="el-icon-arrow-right"></i>
              </span>
              <span v-else>{{(scope.row[scope.column.property] && scope.row[scope.column.property] !== 'null') ? scope.row[scope.column.property] : ''}}</span>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>
    <el-divider></el-divider>
    <span class="t1">操作日志</span>
    <div class="logCont">
      <el-table
        :data="detailInfo.logList"
        style="width:100%;max-height:600px;overflow-y:auto;">
        <template v-if="custom.dataType == 1">
          <el-table-column
            v-for="(item,index) in logcolumnT"
            :key="index"
            :show-overflow-tooltip="true"
            :prop="item.prop"
            :label="item.col"
            :width="item.width"
            :fixed="item.fixed"
          >
            <template slot-scope="scope">
              <span>{{(scope.row[scope.column.property] && scope.row[scope.column.property] !== 'null') ? scope.row[scope.column.property] : ''}}</span>
            </template>
          </el-table-column>
        </template>
        <template v-else>
          <el-table-column
            v-for="(item,index) in logcolumnS"
            :key="index"
            :show-overflow-tooltip="true"
            :prop="item.prop"
            :label="item.col"
            :width="item.width"
            :fixed="item.fixed"
          >
            <template slot-scope="scope">
              <span>{{(scope.row[scope.column.property] && scope.row[scope.column.property] !== 'null') ? scope.row[scope.column.property] : ''}}</span>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>
    <!-- 版本记录弹框 -->
    <el-dialog
      title="版本记录"
      :visible.sync="showVersionLog"
      width="80%">
        <el-table
          :data="detailInfo.versonList"
          :span-method="custom.dataType==1?objectSpanMethodLogT:objectSpanMethodLogS"
          style="width:100%;max-height:500px;">
          <template v-if="custom.dataType == 1">
            <el-table-column
              v-for="(item,index) in goodsInfocolumnT"
              :key="index"
              :show-overflow-tooltip="true"
              :prop="item.prop"
              :label="item.col"
              :width="item.width"
              :fixed="item.fixed"
            >
              <template slot-scope="scope">
                <!-- 单价 -->
                <span v-if="scope.column.property==='univalent'">{{scope.row.univalent | dfFormat}}</span>
                <!-- 货物名称/编码 -->
                <span v-else-if="scope.column.property==='goodsNameCode'">{{scope.row.goodsName}}<span v-if="scope.row.goodsName||scope.row.goodsCode">/</span>{{scope.row.goodsCode}}</span>
                <!-- 货物品类名称/编码 -->
                <span v-else-if="scope.column.property==='goodsCategoryNameCode'">{{scope.row.goodsCategoryName}}<span v-if="scope.row.goodsCategoryName||scope.row.goodsCategoryCode">/</span>{{scope.row.goodsCategoryCode}}</span>
                <!-- 货物种类名称/编码 -->
                <span v-else-if="scope.column.property==='goodsTypeNameCode'">{{scope.row.goodsTypeName}}<span v-if="scope.row.goodsTypeName||scope.row.goodsTypeCode">/</span>{{scope.row.goodsTypeCode}}</span>
                <!-- 增值服务 -->
                <el-popover
                  placement="right"
                  style="min-width:160px"
                  trigger="click"
                  v-else-if="scope.column.property==='driverServiceStrList' && scope.row.operateType!=3"
                >
                  <!-- <div v-for="item in logServiceDetailArry" :key="item.type"> -->
                  <div v-for="item in serviceDetailArry" :key="item.type">
                    <div class="popover_item" v-if="item.type == 1">
                      <span>代收货款：</span>
                      <span>{{item.quantity}}元</span>
                    </div>
                    <div class="popover_item" v-else-if="item.type == 2">
                      <span>送货上门：</span>
                      <span>{{item.floor}}<span v-if="item.floor">楼</span> 货物数量{{item.quantity}}</span>
                    </div>
                    <div class="popover_item" v-else-if="item.type == 3">
                      <span>货物上架：</span>
                      <span>货物数量{{item.quantity}}</span>
                    </div>
                    <div class="popover_item" v-else-if="item.type == 4">
                      <span>位置腾挪：</span>
                      <span>货物数量{{item.quantity}}</span>
                    </div>
                    <div class="popover_item" v-else-if="item.type == 5">
                      <span>退货服务：</span>
                      <span>{{item.quantity}}{{item.calculateUnit}}</span>
                    </div>
                    <div class="popover_item" v-else-if="item.type == 6">
                      <span>装卸搬运：</span>
                      <span>{{item.quantity}}{{item.calculateUnit}}</span>
                    </div>
                  </div>
                  <span slot="reference" style="cursor:pointer;" @click="clickzzfwlog(scope.row)">
                    {{scope.row.driverServiceStrList.join('、')}}
                    <i v-if="scope.row.driverServiceStrList.length > 0" class="el-icon-arrow-right"></i>
                  </span>
                </el-popover>
                <span @click="clickzzfwlog(scope.row)" v-else-if="scope.column.property==='driverServiceStrList' && scope.row.operateType==3" style="cursor:pointer;">
                  {{scope.row.driverServiceStrList.join('、')}}
                  <i v-if="scope.row.driverServiceStrList.length > 0" class="el-icon-arrow-right"></i>
                </span>
                <span v-else>{{(scope.row[scope.column.property] && scope.row[scope.column.property] !== 'null') ? scope.row[scope.column.property] : ''}}</span>
              </template>
            </el-table-column>
          </template>
          <template v-else>
            <el-table-column
              v-for="(item,index) in goodsInfocolumnS"
              :key="index"
              :show-overflow-tooltip="true"
              :prop="item.prop"
              :label="item.col"
              :width="item.width"
              :fixed="item.fixed"
            >
              <template slot-scope="scope">
                <!-- 单价 -->
                <span v-if="scope.column.property==='univalent'">{{scope.row.univalent | dfFormat}}</span>
                <!-- 货物名称/编码 -->
                <span v-else-if="scope.column.property==='goodsNameCode'">{{scope.row.goodsName}}<span v-if="scope.row.goodsName||scope.row.goodsCode">/</span>{{scope.row.goodsCode}}</span>
                <!-- 货物品类名称/编码 -->
                <span v-else-if="scope.column.property==='goodsCategoryNameCode'">{{scope.row.goodsCategoryName}}<span v-if="scope.row.goodsCategoryName||scope.row.goodsCategoryCode">/</span>{{scope.row.goodsCategoryCode}}</span>
                <!-- 货物种类名称/编码 -->
                <span v-else-if="scope.column.property==='goodsTypeNameCode'">{{scope.row.goodsTypeName}}<span v-if="scope.row.goodsTypeName||scope.row.goodsTypeCode">/</span>{{scope.row.goodsTypeCode}}</span>
                <!-- 增值服务 -->
                <el-popover
                  placement="right"
                  style="min-width:160px"
                  trigger="click"
                  v-else-if="scope.column.property==='driverServiceStrList' && scope.row.operateType!=3"
                >
                  <!-- <div v-for="item in logServiceDetailArry" :key="item.type"> -->
                  <div v-for="item in serviceDetailArry" :key="item.type">
                    <div class="popover_item" v-if="item.type == 1">
                      <span>代收货款：</span>
                      <span>{{item.quantity}}元</span>
                    </div>
                    <div class="popover_item" v-else-if="item.type == 2">
                      <span>送货上门：</span>
                      <span>{{item.floor}}<span v-if="item.floor">楼</span> 货物数量{{item.quantity}}</span>
                    </div>
                    <div class="popover_item" v-else-if="item.type == 3">
                      <span>货物上架：</span>
                      <span>货物数量{{item.quantity}}</span>
                    </div>
                    <div class="popover_item" v-else-if="item.type == 4">
                      <span>位置腾挪：</span>
                      <span>货物数量{{item.quantity}}</span>
                    </div>
                    <div class="popover_item" v-else-if="item.type == 5">
                      <span>退货服务：</span>
                      <span>{{item.quantity}}{{item.calculateUnit}}</span>
                    </div>
                    <div class="popover_item" v-else-if="item.type == 6">
                      <span>装卸搬运：</span>
                      <span>{{item.quantity}}{{item.calculateUnit}}</span>
                    </div>
                  </div>
                  <span slot="reference" style="cursor:pointer;" @click="clickzzfwlog(scope.row)">
                    {{scope.row.driverServiceStrList.join('、')}}
                    <i v-if="scope.row.driverServiceStrList.length > 0" class="el-icon-arrow-right"></i>
                  </span>
                </el-popover>
                <span @click="clickzzfwlog(scope.row)" v-else-if="scope.column.property==='driverServiceStrList' && scope.row.operateType==3" style="cursor:pointer;">
                  {{scope.row.driverServiceStrList.join('、')}}
                  <i v-if="scope.row.driverServiceStrList.length > 0" class="el-icon-arrow-right"></i>
                </span>
                <span v-else>{{(scope.row[scope.column.property] && scope.row[scope.column.property] !== 'null') ? scope.row[scope.column.property] : ''}}</span>
              </template>
            </el-table-column>
          </template>
        </el-table>
    </el-dialog>
    <!-- 增值服务明细弹框 -->
    <el-dialog
      title="增值服务明细"
      :visible.sync="showServiceDetail"
      :modal-append-to-body='false'
      width="520px">
      <div class="my_dialogBody">
        <span class="title">增值服务凭证</span>
        <div v-for="item in serviceDetailArry" :key="item.type">
          <div class="item" v-if="item.type == 1">
            <span class="left">代收货款</span>
            <span class="right">{{item.quantity}}元</span>
          </div>
          <div class="item" v-else-if="item.type == 2">
            <span class="left">送货上门</span>
            <span class="right">{{item.floor}}<span v-if="item.floor">楼</span> 货物数量{{item.quantity}}</span>
          </div>
          <div class="item" v-else-if="item.type == 3">
            <span class="left">货物上架</span>
            <span class="right">货物数量{{item.quantity}}</span>
          </div>
          <div class="item" v-else-if="item.type == 4">
            <span class="left">位置腾挪</span>
            <span class="right">货物数量{{item.quantity}}</span>
          </div>
          <div class="item" v-else-if="item.type == 5">
            <span class="left">退货服务</span>
            <span class="right">{{item.quantity}}{{item.calculateUnit}}</span>
          </div>
          <div class="item" v-else-if="item.type == 6">
            <span class="left">装卸搬运</span>
            <span class="right">{{item.quantity}}{{item.calculateUnit}}</span>
          </div>
        </div>
        <!-- 上传凭证部分 -->
        <div class="item" v-if="imgSrcList.length > 0">
          <span class="left">上传凭证:</span>
          <span v-if="imgSrcList.length>10" class="right rightred" @click="imgCloseShowMore">
            收起
            <i class="el-icon-arrow-up" style="margin-left:4px;"></i>
          </span>
          <span v-else-if="imgSrcPreList.length>10" class="right rightred" @click="imgShowMore">
            展开更多
            <i class="el-icon-arrow-down" style="margin-left:4px;"></i>
          </span>
        </div>
        <div class="imgItem" v-if="imgSrcList.length > 0">
          <el-image
            style="width:70px;height:70px;margin-right:16px;margin-top:16px;"
            v-for="(item,index) in imgSrcList" :key="index"
            :src="item"
            :z-index=9999
            :preview-src-list="imgSrcPreList"
          >
          </el-image>
        </div>
        <!-- 分割线 -->
        <div class="divider" v-if="imgSrcList.length > 0"></div>
        <div class="item itemNobot">
          <span class="left">提交时间：</span>
          <span v-if="serviceDetailArry[0] && serviceDetailArry[0].operationTime" class="right">{{serviceDetailArry[0].operationTime}}</span>
          <span v-else class="right"></span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import * as columns from './common/column.js';
export default {
  data() {
    return {
      custom: null,
      loading: false,
      goodsInfocolumnT: columns.goodsInfocolumnT,
      goodsInfocolumnS: columns.goodsInfocolumnS,
      logcolumnT: columns.logcolumnT,
      logcolumnS: columns.logcolumnS,
      detailInfo: {
        baseInfoT: [  //注：数组元素顺序变动会影响赋值，如需跳转需注意基础信息栏字段赋值
          {
            bfield: 'goodsOrderId',
            label: '提货单号：',
            val: ''
          },{
            bfield: 'version',
            label: '提货单版本号：',
            val: ''
          },{
            bfield: 'outerOrderId',
            label: '外部订单号：',
            val: ''
          },{
            bfield: 'customerWaybillId',
            label: '客户运单号：',
            val: ''
          },{
            bfield: 'orderId',
            label: '订单号：',
            val: ''
          },{
            bfield: 'goodsSideNameCode',
            label: '发货方/代码：',
            val: []
          },{
            bfield: 'goodsSideUserNamePhone',
            label: '发货方联系人：',
            val: []
          },{
            bfield: 'address',
            label: '发货方地址：',
            val: ''
          },{
            bfield: 'planData',
            label: '提货日期：',
            val: ''
          },{
            bfield: 'planTimeLimit',
            label: '提货时间：',
            val: ''
          }
        ],
        baseInfoS: [  //注：数组元素顺序变动会影响赋值，如需跳转需注意基础信息栏字段赋值
          {
            bfield: 'goodsOrderId',
            label: '送货单号：',
            val: ''
          },{
            bfield: 'version',
            label: '送货单版本号：',
            val: ''
          },{
            bfield: 'outerOrderId',
            label: '外部订单号：',
            val: ''
          },{
            bfield: 'customerWaybillId',
            label: '客户运单号：',
            val: ''
          },{
            bfield: 'orderId',
            label: '订单号：',
            val: ''
          },{
            bfield: 'goodsSideNameCode',
            label: '发货方/代码：',
            val: []
          },{
            bfield: 'goodsSideUserNamePhone',
            label: '发货方联系人：',
            val: []
          },{
            bfield: 'address',
            label: '发货方地址：',
            val: ''
          },{
            bfield: 'planData',
            label: '送货日期：',
            val: ''
          },{
            bfield: 'planTimeLimit',
            label: '送货时间：',
            val: ''
          }
        ],
        goodsList: [],
        logList: [],
        versonList: []
      },
      showVersionLog: false,
      testPosition1: 0,
      testPosition2: 0,
      testArr1: [],
      testArr2: [],
      showServiceDetail: false,
      serviceDetailArry: [],
      imgSrcList: [],
      imgListMoreArry: [],
      imgSrcPreList: [],
      // logServiceDetailArry: [],
      BACKGROUND: ''
    };
  },
  created() {
    this.custom = JSON.parse(sessionStorage.getItem('manifestDeatilParama'));
    this.BACKGROUND = this.getHostUrl();
  },
  mounted() {
    this.getDetail();
  },
  computed: {},
  filters: {
    dfFormat: function(val) {
      if(val) {
        let y = String(val).indexOf(".") + 1;//获取小数点的位置
        let count = String(val).length - y;//获取小数点后的个数
        if(y > 0 && count > 2) {
          return String(val).substring(0,String(val).indexOf(".")+3)
        }else{
          return val;
        }
      } else {
        return val;
      }
    }
  },
  methods: {
    ...mapActions([
      'manifestDetailApi',
    ]),
    getHostUrl() {
      return location.protocol + "//" + location.host;
    },
    // 点击增值服务数据
    clickzzfw(row) {
      if(row.operateType ==3) {
        this.serviceDetailArry = row.appreciationServiceDtoList || [];
        this.imgSrcPreList = row.appreciationServiceDtoList[0].picList || [];
        if(this.imgSrcPreList.length > 0) {
          for(let i=0,l=this.imgSrcPreList.length; i<l; i++) {
            if(!this.imgSrcPreList[i].includes(this.BACKGROUND)){
              this.imgSrcPreList[i] = `${this.BACKGROUND}/saas/companyQualification/viewImage?objectName=${this.imgSrcPreList[i]}`
            }
          }
        }
        if(this.imgSrcPreList.length > 10) {
          this.imgSrcList = this.imgSrcPreList.slice(0,10);
          this.imgListMoreArry = this.imgSrcPreList.slice(10);
        }else{
          this.imgSrcList = this.imgSrcPreList;
          this.imgListMoreArry = [];
        }
        this.showServiceDetail = true;
      }else{
        this.serviceDetailArry = row.appreciationServiceDtoList || [];
      }
    },
    // 版本记录弹框点击“增值服务数据”
    clickzzfwlog(row) {
      if(row.operateType ==3) {
        // this.logServiceDetailArry = row.appreciationServiceDtoList || [];
        this.serviceDetailArry = row.appreciationServiceDtoList || [];
        this.imgSrcPreList = row.appreciationServiceDtoList[0].picList || [];
        if(this.imgSrcPreList.length > 0) {
          for(let i=0,l=this.imgSrcPreList.length; i<l; i++) {
            if(!this.imgSrcPreList[i].includes(this.BACKGROUND)){
              this.imgSrcPreList[i] = `${this.BACKGROUND}/saas/companyQualification/viewImage?objectName=${this.imgSrcPreList[i]}`
            }
          }
        }
        if(this.imgSrcPreList.length > 10) {
          this.imgSrcList = this.imgSrcPreList.slice(0,10);
          this.imgListMoreArry = this.imgSrcPreList.slice(10);
        }else{
          this.imgSrcList = this.imgSrcPreList;
          this.imgListMoreArry = [];
        }
        this.showServiceDetail = true;
      }else{
        // this.logServiceDetailArry = row.appreciationServiceDtoList || [];
        this.serviceDetailArry = row.appreciationServiceDtoList || [];
      }
    },
    // 弹框图片点击展开更多
    imgShowMore() {
      this.imgSrcList = [...this.imgSrcList, ...this.imgListMoreArry]
    },
    // 弹框图片点击收起
    imgCloseShowMore() {
      this.imgSrcList = this.imgSrcPreList.slice(0,10);
      this.imgListMoreArry = this.imgSrcPreList.slice(10);
    },
    // 获取详情信息
    getDetail() {
      this.loading = true;
      this.manifestDetailApi(this.custom).then(
          (response) => {
            this.loading = false;
            if(this.custom.dataType == 1) {
              this.detailInfo.baseInfoT[0].val = response.goodsOrderId;
              this.detailInfo.baseInfoT[1].val = response.version;
              this.detailInfo.baseInfoT[2].val = response.outerOrderId;
              this.detailInfo.baseInfoT[3].val = response.customerWaybillId;
              this.detailInfo.baseInfoT[4].val = response.orderId;
              this.detailInfo.baseInfoT[5].val[0] = response.goodsSideName;
              this.detailInfo.baseInfoT[5].val[1] = response.goodsSideCode;
              this.detailInfo.baseInfoT[6].val[0] = response.contactName;
              this.detailInfo.baseInfoT[6].val[1] = response.contactPhone;
              this.detailInfo.baseInfoT[7].val = response.address;
              this.detailInfo.baseInfoT[8].val = response.planData;
              this.detailInfo.baseInfoT[9].val = response.planTimeLimit;
            } else {
              this.detailInfo.baseInfoS[0].val = response.goodsOrderId;
              this.detailInfo.baseInfoS[1].val = response.version;
              this.detailInfo.baseInfoS[2].val = response.outerOrderId;
              this.detailInfo.baseInfoS[3].val = response.customerWaybillId;
              this.detailInfo.baseInfoS[4].val = response.orderId;
              this.detailInfo.baseInfoS[5].val[0] = response.goodsSideName;
              this.detailInfo.baseInfoS[5].val[1] = response.goodsSideCode;
              this.detailInfo.baseInfoS[6].val[0] = response.contactName;
              this.detailInfo.baseInfoS[6].val[1] = response.contactPhone;
              this.detailInfo.baseInfoS[7].val = response.address;
              this.detailInfo.baseInfoS[8].val = response.planData;
              this.detailInfo.baseInfoS[9].val = response.planTimeLimit;
            }
            this.detailInfo.goodsList = response.goodsList;
            this.detailInfo.logList = response.deliveryLogList;
            this.detailInfo.versonList = response.logGoodsList;
            if(this.detailInfo.goodsList && this.detailInfo.goodsList.length>0) {
              this.rowspan(this.testArr1, this.testPosition1, "operateTypeStr")
            }
          },
          (response) => {
            this.loading = false;
          }
        );
    },
    // 点击版本记录
    clickVersinLog() {
      this.showVersionLog = !this.showVersionLog
    },
    // 表格合并行
    rowspan(spanArr, position, spanName) {
      this.detailInfo.goodsList.forEach((item, index) => {
        if (index === 0) {
          spanArr.push(1)
          position = 0
        } else {
          if (
            this.detailInfo.goodsList[index][spanName]===this.detailInfo.goodsList[index - 1][spanName]
          ) {
            spanArr[position] += 1
            spanArr.push(0)
          } else {
            spanArr.push(1)
            position = index
          }
        }
      });
      this.detailInfo.versonList.forEach((item, index) => {
        if (index === 0) {
          this.testArr2.push(1)
          this.testPosition2 = 0
        } else {
          if (
            this.detailInfo.versonList[index][spanName]===this.detailInfo.versonList[index - 1][spanName]
          ) {
            this.testArr2[this.testPosition2] += 1
            this.testArr2.push(0)
          } else {
            this.testArr2.push(1)
            this.testPosition2 = index
          }
        }
      })
    },
    objectSpanMethodT({ row, column, rowIndex, columnIndex }) {
      if(this.goodsInfocolumnT[columnIndex+1]) {
        if (this.goodsInfocolumnT[columnIndex+1].mergeRow) {
          const _row = this.testArr1[rowIndex]
          const _col = _row > 0 ? 1 : 0
          return {
            rowspan: _row,
            colspan: _col,
          }
        }else{
          return{
            rowspan: [],
            colspan: [],
          }
        }
      }
    },
    objectSpanMethodS({ row, column, rowIndex, columnIndex }) {
      if(this.goodsInfocolumnS[columnIndex+1]) {
        if (this.goodsInfocolumnS[columnIndex+1].mergeRow) {
          const _row = this.testArr1[rowIndex]
          const _col = _row > 0 ? 1 : 0
          return {
            rowspan: _row,
            colspan: _col,
          }
        }
      }
    },
    objectSpanMethodLogT({ row, column, rowIndex, columnIndex }) {
      if(this.goodsInfocolumnT[columnIndex+1]) {
        if (this.goodsInfocolumnT[columnIndex+1].mergeRow) {
          const _row = this.testArr2[rowIndex]
          const _col = _row > 0 ? 1 : 0
          return {
            rowspan: _row,
            colspan: _col,
          }
        }else{
          return{
            rowspan: [],
            colspan: [],
          }
        }
      }
    },
    objectSpanMethodLogS({ row, column, rowIndex, columnIndex }) {
      if(this.goodsInfocolumnS[columnIndex+1]) {
        if (this.goodsInfocolumnS[columnIndex+1].mergeRow) {
          const _row = this.testArr2[rowIndex]
          const _col = _row > 0 ? 1 : 0
          return {
            rowspan: _row,
            colspan: _col,
          }
        }
      }
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-divider--horizontal{
  margin: 24px 0 !important;
}
.my_dialogBody{
  padding: 22px !important;
  padding-bottom: 28px !important;
  .title{
    display: block;
    margin-bottom: 24px !important;
    font-size: 16px;
    color: #000000;
    font-weight: 500;
  }
  .item{
    margin-bottom: 24px !important;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    font-weight: 400;
    .left{
      color: #666666;
    }
    .right{
      color: #000000;
    }
    .rightred{
      color:#DC1E32;
      cursor: pointer;
    }
  }
  .itemNobot{
    margin-bottom: 0;
  }
  .imgItem{
    margin-top: -30px !important;
    img{
      display: inline-block;
      width: 70px;
    }
  }
  .divider{
    margin: 24px 0 !important;
    border-bottom: 1px solid rgba(234,234,234,1);
  }
}
.wrapper {
  padding: 14px 12px !important;
  box-sizing: border-box;
  /deep/ .cell {
    padding-right: 8px !important;
    box-sizing: border-box;
  }
  .t1{
    font-size: 16px;
    color: #000000;
    display: inline-block;
  }
  .t1r{
    float: right;
    font-size: 14px;
    color: #409EFF;
    cursor: pointer !important;
    display: inline-block;
  }
  .t1s{
    margin-top: 20px !important;
  }
  .basecont,
  .goodsCont,
  .logCont{
    overflow: hidden;
    margin-top: 18px !important;
    margin-bottom: 18px !important;
    .itemcont{
      .item{
        float: left;
        width: 25%;
        padding: 8px 0 !important;
        padding-right: 8px !important;
        box-sizing: border-box;
        display: flex;
        align-items: top;
        line-height: 19px;
        .left{
          font-size: 14px;
          color: #888888;
        }
        .right{
          flex: 1;
          font-size: 14px;
          color: #000000;
        }
      }
    }
  }
}
.goodsCont {
  margin-bottom: 30px !important;
}
.popover_item{
  height: 32px;
  line-height: 32px;
  font-size: 12px;
  font-weight: 500;
}
</style>